const BaseUrl = {
  phar_Loc: "000",
  defCountryFlagPath: "https://flagsapi.com/IN/flat/24.png",

  // Host only (no /DocChoiceWebServices and no /patientportalapi suffix)
  baseUrl: process.env.REACT_APP_API_BASE_URL || "https://demo.docchoice.com",

  // New WAR on the same Tomcat as demo
  patientPortalApiBaseUrl:
    process.env.REACT_APP_PATIENTPORTAL_API_BASE_URL ||
    "https://demo.docchoice.com/patientportalapi",

  /**
   * true  → patientPortalApiBaseUrl + mapped /api/... (or legacy alias)
   * false → patientPortalApiBaseUrl + legacy path
   */
  usePatientPortalApi:
    String(process.env.REACT_APP_USE_PATIENTPORTAL_API || "true").toLowerCase() ===
    "true",

  // Used for POST /api/auth/token (X-Client-Secret). Must match app.client-secret on the API.
  patientPortalClientSecret:
    process.env.REACT_APP_PATIENTPORTAL_CLIENT_SECRET ||
    "92af164b2f06b2306bb7de947ecad8e09bfa46de087814b13c6cb715895df6e2",

  // Static bearer accepted by ApiTokenFilter (app.api-token). Used if /api/auth/token fails.
  patientPortalApiToken:
    process.env.REACT_APP_PATIENTPORTAL_API_TOKEN ||
    "bbf55c2c961541f8e81324fc761b8a2fb9cd27def02fda3c51590f59d924dc49",

  key_endpt: "rzp_test_QqNlvtSpONl79U",
  secret_Key: "NH5DRIZlpdrCERmW3MqX6YjL",
  payU_base_url: "https://sandboxsecure.payu.in/_payment",
};
export default BaseUrl;

